import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeBaseComponentSkeleton } from './TypeBaseComponent'

export interface TypeTypeformComponentFields {
  title: EntryFieldTypes.Symbol
  anchorTag?: EntryFieldTypes.Symbol
  typeformId: EntryFieldTypes.Symbol
  base: EntryFieldTypes.EntryLink<TypeBaseComponentSkeleton>
}

export type TypeTypeformComponentSkeleton = EntrySkeletonType<TypeTypeformComponentFields, 'typeformComponent'>
export type TypeTypeformComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypeTypeformComponentSkeleton,
  Modifiers,
  Locales
>

export function isTypeTypeformComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeTypeformComponent<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'typeformComponent'
}
